export class Region {
    id: number;
    name: string;
    host: string;
    displayName: string;

    constructor(data) {
        this.id = (data.region_id || data.ahec_pk) ? parseInt(data.region_id ? data.region_id : data.ahec_pk) : null
        this.name = (data.name || data.ahec_name) ? data.name ? data.name : data.ahec_name : null
        this.displayName = ( this.name ) ? this.id == 6 ? 'MAHEC' : `${this.name} AHEC` : null
    }
}
